/**
 * Home Page Content — Huqup Cafe & Grill, Little Elm TX
 *
 * SEO-optimized content for all home page sections.
 * Targets: Mediterranean restaurant Little Elm, hookah lounge DFW,
 * Middle Eastern food near me, best kebabs Little Elm TX.
 */

const homeContent = {
  /* ──────────── Banner / Hero Slider ──────────── */
  banner: {
    slides: [
      {
        id: 3,
        image: 'slider-3.jpg',
        subtitle: 'premium hookah lounge',
        headingLine1: 'Unwind with Friends',
        headingLine2: 'and Great Food',
        text: 'Over 70 hookah flavors paired with artisan pizzas, grilled entrees & specialty drinks',
      },
      {
        id: 1,
        image: 'slider-1.jpg',
        subtitle: 'authentic Mediterranean cuisine',
        headingLine1: 'Savor the Flavors of',
        headingLine2: 'the Mediterranean',
        text: 'Handcrafted kebabs, mezze platters & premium hookah in Little Elm, TX',
      },
      {
        id: 2,
        image: 'slider-2.jpg',
        subtitle: "Little Elm's favorite cafe & grill",
        headingLine1: 'Where Every Bite',
        headingLine2: 'Tells a Story',
        text: 'Fresh ingredients, bold spices & family recipes served daily until 2 AM',
      },
    ],
    cta: { label: 'view our menu', link: '/menu' },
    bookButton: { label: 'book a table', icon: 'book-icon-1.png' },
  },

  /* ──────────── Feature Cards ──────────── */
  features: [
    {
      id: 1,
      image: 'featured-1.jpg',
      subtitle: 'our menu',
      title: 'Signature Grilled Entrees',
      text: 'Lamb chops, kebabs & tender grilled salmon.',
      cta: { label: 'view menu', link: '/menu' },
    },
    {
      id: 2,
      image: 'featured-2.jpg',
      subtitle: 'relax & enjoy',
      title: 'Premium Hookah Lounge',
      text: '70+ flavors from Al Fakher, Fumari & more.',
      cta: { label: 'explore', link: '/menu#hookah' },
    },
    {
      id: 3,
      image: 'featured-3.jpg',
      subtitle: "chef's pick",
      title: 'Jordanian Lamb Mansef',
      text: 'Our signature dish — authentic & unforgettable.',
      cta: { label: 'view menu', link: '/menu' },
    },
  ],

  /* ──────────── Our Story ──────────── */
  story: {
    subtitle: 'Our Story',
    title: 'A Taste of the Mediterranean in Little Elm',
    text: "At Huqup Cafe & Grill, we bring the rich, bold flavors of Mediterranean, Middle Eastern, Pakistani, and Indian cuisines to the heart of Little Elm, Texas. Every dish is crafted from scratch using fresh, locally sourced ingredients and time-honored family recipes — from our signature Jordanian Lamb Mansef to hand-seasoned grilled kebabs and freshly baked artisan pizzas. Whether you're gathering for a family dinner, relaxing in our premium hookah lounge, or grabbing a late-night bite, Huqup is your destination for authentic flavors and warm hospitality, open Sunday–Thursday 11 AM – 2 AM, and Friday–Saturday until 3 AM.",
    phone: {
      label: 'Book Through Call',
      number: '+1 (469) 724-1846',
      link: 'tel:+14697241846',
    },
    cta: { label: 'Read More', link: '/about' },
    images: {
      background: 'bg-3.png',
      badge: 'badge-1.png',
      main: 'image-1.jpg',
      secondary: 'image-2.jpg',
    },
  },

  /* ──────────── We Offer ──────────── */
  offers: {
    subtitle: 'what we serve',
    title: 'Signature Experiences',
    text: 'From hand-seasoned grilled kebabs and authentic mezze platters to our premium hookah lounge with 70+ flavors, Huqup Cafe & Grill delivers an unforgettable dining experience in Little Elm, TX.',
    items: [
      { id: 1, title: 'Kebabs & Grill', image: 'offer-image-1.jpg', link: '/menu#parent-kitchen' },
      { id: 2, title: 'Premium Hookah', image: 'offer-image-2.jpg', link: '/menu#hookah' },
      { id: 3, title: 'Specialty Drinks', image: 'offer-image-3.jpg', link: '/menu#parent-beverages' },
    ],
    cta: { label: 'view menu', link: '/menu' },
  },

  /* ──────────── Special Dish (Promo) ──────────── */
  specialDish: {
    subtitle: "Chef's Signature",
    title: 'Jordanian Lamb Mansef',
    text: 'A timeless Jordanian masterpiece — tender slow-cooked lamb served over fragrant seasoned rice with a rich, tangy yogurt sauce and toasted pine nuts. Our most celebrated dish, prepared with authentic family recipes passed down through generations.',
    newPrice: '$24.00',
    cta: { label: 'view all menu', link: '/menu' },
  },

  /* ──────────── Live Sports & Big Screen ──────────── */
  liveSports: {
    subtitle: 'The Ultimate Game Day Experience',
    title: 'One of the Largest Screens in DFW',
    text: "Watch every play, goal, and knockout on one of the biggest screens in the Dallas–Fort Worth area — right here at Huqup Cafe & Grill. Whether it's NFL Sunday, an NBA playoff showdown, a Premier League clash, a UFC championship bout, a World Cup cricket thriller, or a Grand Slam tennis final, our massive screen delivers every live event in stunning high-definition. Pair exceptional viewing with handcrafted Mediterranean cuisine, premium hookah, and an electric atmosphere that turns every game into an unforgettable experience.",
    sports: [
      { name: 'NFL', icon: 'fas fa-football-ball' },
      { name: 'NBA', icon: 'fas fa-basketball-ball' },
      { name: 'Soccer', icon: 'fas fa-futbol' },
      { name: 'UFC', icon: 'fas fa-fist-raised' },
      { name: 'Cricket', icon: 'fas fa-baseball-ball' },
      { name: 'Tennis', icon: 'fas fa-table-tennis' },
    ],
    highlight: 'Live events every week — reserve your spot today',
  },

  /* ──────────── Best Specialties Carousel ──────────── */
  specials: {
    subtitle: 'house favorites',
    title: 'Best Specialties',
    items: [
      {
        id: 1,
        name: 'Lamb Chops',
        description: 'Premium lamb chops marinated in Mediterranean spices, grilled to perfection',
        price: '$27',
        image: 'menu-image-11.jpg',
      },
      {
        id: 2,
        name: 'Tandoori Chicken Pizza',
        description: 'A fusion of Indian spices and Italian tradition — tandoori chicken on a hand-tossed pizza crust with mozzarella & cilantro',
        price: '$14/$16',
        image: 'menu-image-12.jpg',
      },
      {
        id: 3,
        name: 'Turkish Coffee',
        description: 'Freshly brewed Turkish coffee with a rich, aromatic flavor',
        price: '$4',
        image: 'menu-image-13.jpg',
      },
      {
        id: 4,
        name: "Kunafa",
        description: 'A traditional Middle Eastern dessert made with layers of shredded phyllo dough, sweet cheese, and syrup',
        price: '$9',
        image: 'menu-image-14.jpg',
      },
    ],
    cta: { label: 'view all menu', link: '/menu' },
  },

  /* ──────────── Why Choose Us ──────────── */
  whyUs: {
    subtitle: 'why choose us',
    title: 'The Huqup Difference',
    items: [
      {
        id: 1,
        icon: 'why-icon-1.png',
        title: 'Authentic Recipes',
        text: 'Traditional Mediterranean & Middle Eastern dishes made from scratch daily.',
      },
      {
        id: 2,
        icon: 'why-icon-2.png',
        title: 'Premium Hookah',
        text: '70+ flavors from top brands in a relaxing, stylish lounge atmosphere.',
      },
      {
        id: 3,
        icon: 'why-icon-3.png',
        title: 'Expert Chefs',
        text: 'Skilled chefs with decades of experience in Mediterranean, Pakistani, and Indian cuisines.',
      },
      {
        id: 4,
        icon: 'why-icon-4.png',
        title: 'Open Late Daily',
        text: 'Sun–Thu 11 AM – 2 AM, Fri–Sat 11 AM – 3 AM — perfect for lunch, dinner & late-night cravings.',
      },
    ],
  },

  /* ──────────── Video Section ──────────── */
  videoSection: {
    subtitle: 'experience huqup',
    title: 'Watch Our Story',
    backgroundImage: 'image-3.jpg',
    quote: 'Where authentic Mediterranean flavors meet warm Texas hospitality — welcome to Huqup.',
    quoteAuthor: 'Huqup Cafe & Grill',
    videoUrl: '//www.youtube.com/embed/ZETY_l3GVQg?autoplay=1&autohide=1&fs=1&rel=0&hd=1&wmode=transparent&enablejsapi=1&html5=1',
    stats: [
      { id: 1, value: 200, suffix: '+', label: 'daily', sublabel: 'guests' },
      { id: 2, value: 100, suffix: '+', label: 'menu', sublabel: 'items' },
      { id: 3, value: 70, suffix: '+', label: 'hookah', sublabel: 'flavors' },
      { id: 4, value: 15, suffix: '+', label: 'hours', sublabel: 'daily' },
    ],
  },

  /* ──────────── Testimonials ──────────── */
  testimonials: {
    items: [
      {
        id: 1,
        quote: "The Jordanian Lamb Mansef at Huqup is the most authentic I've had outside of the Middle East. Incredible flavors and the most welcoming staff in Little Elm!",
        author: 'Sarah M.',
        image: 'author-thumb-1.jpg',
      },
      {
        id: 2,
        quote: 'Best hookah lounge in the DFW area, hands down. Great ambiance, amazing food, and open late — we come here every weekend.',
        author: 'James K.',
        image: 'author-thumb-2.jpg',
      },
      {
        id: 3,
        quote: "We hosted our family gathering at Huqup and ordered the King's Platter. The portions were generous and every single dish was bursting with flavor.",
        author: 'Amira R.',
        image: 'author-thumb-3.jpg',
      },
    ],
  },

  /* ──────────── Online Reservation ──────────── */
  reservation: {
    title: 'For Reservations',
    bookingPhone: '+1 (469) 724-1846',
    bookingText: 'Booking request',
    personOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    timeSlots: [
      '11 : 00 am', '12 : 00 pm', '01 : 00 pm', '02 : 00 pm',
      '03 : 00 pm', '04 : 00 pm', '05 : 00 pm', '06 : 00 pm',
      '07 : 00 pm', '08 : 00 pm', '09 : 00 pm', '10 : 00 pm',
      '11 : 00 pm', '12 : 00 am', '01 : 00 am',
    ],
  },

  /* ──────────── Recent Updates / Events ──────────── */
  recentUpdates: {
    subtitle: "what's new",
    title: 'Latest at Huqup',
    items: [
      {
        id: 1,
        date: '01/02/2026',
        image: 'news-2.jpg',
        category: 'New Menu',
        title: 'Artisan Pizzas Now Available — Handmade Mediterranean-Style',
        link: '/menu',
      },
      {
        id: 2,
        date: '15/01/2026',
        image: 'news-1.jpg',
        category: 'Hookah',
        title: 'Happy Hour Hookah — Premium Flavors at Special Prices',
        link: '/menu',
      },
      {
        id: 3,
        date: '01/01/2026',
        image: 'news-3.jpg',
        category: "Chef's Special",
        title: 'Try Our Jordanian Lamb Mansef — A Taste of Authentic Jordan',
        link: '/menu',
      },
    ],
    cta: { label: 'view our blog', link: '#' },
  },
};

export default homeContent;
